import { cx } from "shared/utils";

interface CountNotificationProps {
  totalCount?: number;
  className?: string;
}

export const CountNotification = ({
  totalCount,
  className
}: CountNotificationProps) => {
  if (!totalCount) return null;

  return (
    <span
      className={cx(
        "inline-block font-bold rounded bg-primary-500 text-xxs text-white px-1",
        className
      )}
    >
      {totalCount}
    </span>
  );
};
